<template>
  <div id="search-section">
    <div class="desktop-wrapper desktop-only" :style="cssProps">
      <search-engine class="desktop-margins" />
    </div>
    <search-engine v-if="mobile" class="mobile-margins mobile-only"/>
  </div>
</template>

<script>
import SearchEngine from "@/components/SearchEngine";
import { mapState } from "vuex";

export default {
  name: "search",
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/images/home-background.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: `rgba(0,0,0,.5)`
      },
      mobile: window.innerWidth <= 781
    };
  },
  computed: {
    ...mapState([])
  },
  props: {
    preferredCabin: {
      type: String,
      default: "Economy"
    },
    adults: {
      type: String,
      default: "1"
    },
    children: {
      type: String,
      default: "0"
    },
    infants: {
      type: String,
      default: "0"
    },
    // Airport code eg: CPT
    departureAirport: {
      type: String,
      default: null
    },
    arrivalAirport: {
      type: String,
      default: null
    },
    // dates can be any format
    departureDate: {
      type: String,
      default: null
    },
    returnDate: {
      type: String,
      default: null
    },
    // return, multi, oneway
    tripType: {
      type: String,
      default: "return"
    },
    multi1_departureAirport: {
      type: String,
      default: null
    },
    multi1_arrivalAirport: {
      type: String,
      default: null
    },
    multi1_departureDate: {
      type: String,
      default: null
    },
    multi2_departureAirport: {
      type: String,
      default: null
    },
    multi2_arrivalAirport: {
      type: String,
      default: null
    },
    multi2_departureDate: {
      type: String,
      default: null
    },
    multi3_departureAirport: {
      type: String,
      default: null
    },
    multi3_arrivalAirport: {
      type: String,
      default: null
    },
    multi3_departureDate: {
      type: String,
      default: null
    }
  },
  methods: {
    setUrlSearchParameters() {
      this.$store.commit("setUrlSearchParameters", {
        departureDate: this.departureDate,
        departureAirport: this.departureAirport,
        arrivalAirport: this.arrivalAirport,
        preferredCabin: this.preferredCabin,
        adults: this.adults,
        children: this.children,
        infants: this.infants,
        returnDate: this.returnDate,
        tripType: this.tripType,
        multi1_departureDate: this.multi1_departureDate,
        multi1_departureAirport: this.multi1_departureAirport,
        multi1_arrivalAirport: this.multi1_arrivalAirport,
        multi2_departureDate: this.multi2_departureDate,
        multi2_departureAirport: this.multi2_departureAirport,
        multi2_arrivalAirport: this.multi2_arrivalAirport,
        multi3_departureDate: this.multi3_departureDate,
        multi3_departureAirport: this.multi3_departureAirport,
        multi3_arrivalAirport: this.multi3_arrivalAirport
      });
    }
  },
  mounted() {
    if (this.departureDate) {
      this.setUrlSearchParameters();
    }
  },
  created() {},
  components: {
    SearchEngine
  }
};
</script>


<style lang="scss" scoped>
@import "../assets/styles/settings.scss";

#search-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.desktop-wrapper {
  width: 100vw;
}

.desktop-margins {
  margin-top: 15vh;
  margin-bottom: 15vh;
  margin-left: 7vw;
}

.mobile-margins {
  margin: 1.5em 0.5em;
}
</style>